module.exports = __webpack_public_path__ + "static/img/code3.cfaf839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code3.jpg
// module id = bH94
// module chunks = 56